var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from '@xstyled/styled-components';
import get from 'lodash/fp/get';
import { ToastError, ToastSuccess } from '../../../../Elements/Icon';
var Center = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"])));
var BoolIcon = function (_a) {
    var rowData = _a.rowData, column = _a.column;
    var value = get(column.name, rowData);
    var icon = value ? _jsx(ToastSuccess, {}) : _jsx(ToastError, {});
    return _jsx(Center, { children: icon });
};
export var BoolIconCell = React.memo(BoolIcon);
var templateObject_1;
